import type { ExperimentFormData } from "../types/experiment.types";

export const RESEARCH_OBJECTIVE_MIN_LENGTH = 30;
export const PRIMARY_HYPOTHESIS_MIN_LENGTH = 50;

export interface ResearchStepValidationResult {
  isValid: boolean;
  missingFields: string[];
  errors: Record<string, string>;
}

export const getResearchObjectiveError = (
  value?: string | null,
): string | null => {
  const trimmedValue = value?.trim() ?? "";

  if (!trimmedValue) {
    return "Research objective is required.";
  }

  if (trimmedValue.length < RESEARCH_OBJECTIVE_MIN_LENGTH) {
    return `Research objective should be at least ${RESEARCH_OBJECTIVE_MIN_LENGTH} characters.`;
  }

  return null;
};

export const getPrimaryHypothesisError = (
  value?: string | null,
): string | null => {
  const trimmedValue = value?.trim() ?? "";

  if (!trimmedValue) {
    return "Primary hypothesis is required.";
  }

  if (trimmedValue.length < PRIMARY_HYPOTHESIS_MIN_LENGTH) {
    return `Primary hypothesis should be at least ${PRIMARY_HYPOTHESIS_MIN_LENGTH} characters.`;
  }

  /*If needed use for future use */

  // const hasRequiredStructure =
  //   /\bif\b/i.test(trimmedValue) &&
  //   /\bthen\b/i.test(trimmedValue) &&
  //   /\bbecause\b/i.test(trimmedValue);

  // if (!hasRequiredStructure) {
  //   return "Primary hypothesis should follow an If / then / because structure.";
  // }

  return null;
};

export const validateResearchStep = (
  experimentData: Pick<
    ExperimentFormData,
    "researchObjective" | "primaryHypothesis"
  >,
): ResearchStepValidationResult => {
  const errors: Record<string, string> = {};
  const missingFields: string[] = [];
  const researchObjectiveError = getResearchObjectiveError(
    experimentData.researchObjective,
  );
  const primaryHypothesisError = getPrimaryHypothesisError(
    experimentData.primaryHypothesis,
  );

  if (researchObjectiveError) {
    errors.researchObjective = researchObjectiveError;
    missingFields.push("research objective");
  }

  if (primaryHypothesisError) {
    errors.primaryHypothesis = primaryHypothesisError;
    missingFields.push("primary hypothesis");
  }

  return {
    isValid: missingFields.length === 0,
    missingFields,
    errors,
  };
};
